import ForbiddenPage from "@/components/ui/ForbiddenPage/ForbiddenPage";
import { slices } from "@/constants/sliceNames";
import { UserRolesEnum } from "@/constants/UserRolesEnum";
import { isSuperAdmin } from "@/utils/utils";
import React from "react";
import { useSelector } from "react-redux";

import useShouldWait from "./useShouldWait";

const rolesToFuncs = {
  [UserRolesEnum.SUPER_ADMIN]: isSuperAdmin,
};

export default function AvailableForUserRole({ role, children }) {
  const { userRole } = useSelector((state) => state[slices.auth]);

  const isAvailableForRole = rolesToFuncs[role](userRole);

  return <>{useShouldWait() ? <></> : isAvailableForRole ? children : <ForbiddenPage />}</>;
}
